import { render, staticRenderFns } from "./alumno.vue?vue&type=template&id=1ad22ffa&"
import script from "./alumno.component.ts?vue&type=script&lang=ts&"
export * from "./alumno.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports